import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { IconColors, SimpleIcon } from './icon-utils';

export function SmallRevertToDraftIcon({
  className,
  fill = IconColors.Primary,
  height,
  width,
}: SimpleIconInterface): JSX.Element {
  return (
    <SimpleIcon
      className={className}
      height={height ?? 20}
      viewBoxDimensions="0 0 20 20"
      width={width ?? 20}
    >
      <path
        d="M9.9974 14.1665C10.2335 14.1665 10.4314 14.0866 10.5911 13.9269C10.7509 13.7672 10.8307 13.5693 10.8307 13.3332C10.8307 13.0971 10.7509 12.8991 10.5911 12.7394C10.4314 12.5797 10.2335 12.4998 9.9974 12.4998C9.76128 12.4998 9.56337 12.5797 9.40365 12.7394C9.24392 12.8991 9.16406 13.0971 9.16406 13.3332C9.16406 13.5693 9.24392 13.7672 9.40365 13.9269C9.56337 14.0866 9.76128 14.1665 9.9974 14.1665ZM9.16406 10.8332H10.8307V5.83317H9.16406V10.8332ZM9.9974 18.3332C8.84462 18.3332 7.76128 18.1144 6.7474 17.6769C5.73351 17.2394 4.85156 16.6457 4.10156 15.8957C3.35156 15.1457 2.75781 14.2637 2.32031 13.2498C1.88281 12.2359 1.66406 11.1526 1.66406 9.99984C1.66406 8.84706 1.88281 7.76373 2.32031 6.74984C2.75781 5.73595 3.35156 4.854 4.10156 4.104C4.85156 3.354 5.73351 2.76025 6.7474 2.32275C7.76128 1.88525 8.84462 1.6665 9.9974 1.6665C11.1502 1.6665 12.2335 1.88525 13.2474 2.32275C14.2613 2.76025 15.1432 3.354 15.8932 4.104C16.6432 4.854 17.237 5.73595 17.6745 6.74984C18.112 7.76373 18.3307 8.84706 18.3307 9.99984C18.3307 11.1526 18.112 12.2359 17.6745 13.2498C17.237 14.2637 16.6432 15.1457 15.8932 15.8957C15.1432 16.6457 14.2613 17.2394 13.2474 17.6769C12.2335 18.1144 11.1502 18.3332 9.9974 18.3332Z"
        fill={fill}
      />
    </SimpleIcon>
  );
}
